module.exports = __webpack_public_path__ + "static/media/group26.fe8af93f.png";